export type Scheme = 'dark' | 'light';

export interface AppConfig {
    scheme: Scheme;
}

export const appConfig: AppConfig = {
    scheme: 'light',
};
